import axios from 'axios'

export default {
  studentList: function (query: any = null) {
    return axios.get("/reports/student-list", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  studentProgress: function (params: any = null) {
    return new Promise(resolve => {
      axios.get('/reports/student-progress-count/', {
        params: params,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('error ' + error)
          resolve(error)
        })
    })
  },
  studentInProgressCourses: function (userId:any, payload: any) {
    return new Promise(resolve => {
      axios.get('/reports/student-progress/' + userId, {
        params: payload,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          console.log('error ' + error)
          resolve(error)
        })
    })
  },
  courseWiseEvaluation: function (query: any = null) {
    return axios.get("/reports/course-wise-evaluation", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  courseWiseEnrollmentCount: function (query: any = null) {
    return axios.get("/reports/course-wise-enrollment-count", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  userWiseCourseEnrollment: function (query: any = null) {
    return axios.get("/reports/user-wise-course-enrollment", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
  generateCertificateByAdmin: function (enrolment_id: any = null) {
    return axios.get("/reports/generate-certificate/" + enrolment_id)
      .then((response) => {
        return response.data
      })
  },
  orderList: function (params: any = null) {
    /*let params = {page: currentPage}
    params = {...query, ...params};*/

    return axios.get("/reports/orders", {
      params: params
    })
  },

  topNCoursesWatchTime: function (n: any = null) {
    return axios.get('/reports/top-n-courses-watch-time/' + n)
      .then((response) => {
        return response.data
      })
  },

  subscriptionsUserWatchDuration: function (params: any = null) {
    return axios.get("/reports/subscriptions/user-watch-duration", {
      params: params
    }).then((response) => {
      return response.data
    })
  },

  subscriptionsCourseWatchDuration: function (params: any = null) {
    return axios.get("/reports/subscriptions/course-watch-duration", {
      params: params
    }).then((response) => {
      return response.data
    })
  },

  affiliatePerformance: function (query: any = null) {
    return axios.get("/reports/affiliate/performance", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },

  walletDisbursement: function (query: any = null) {
    return axios.get("/reports/point-disbursement", {
      params: query
    })
      .then((response) => {
        return response.data
      })
  },
}
